import { Link, useLocation, useNavigate } from "react-router-dom";
import { Clock, Mail, MapPin, Phone } from "lucide-react";
import { Logo } from "./Logo";
import { SITE } from "../data/site";
import { MACHINES } from "../data/machines";
import { useSectionNav } from "../lib/nav";

const NAV = [
  { label: "Ana Sayfa", hash: "" },
  { label: "Hakkımızda", hash: "hakkimizda" },
  { label: "Makinelerimiz", hash: "makineler" },
  { label: "Galeri", hash: "galeri" },
  { label: "İletişim", hash: "iletisim" },
];

export default function Footer() {
  const navigate = useNavigate();
  const location = useLocation();
  const nav = useSectionNav(navigate, location);

  return (
    <footer className="bg-ink-deep text-paper/70">
      <div className="mx-auto grid max-w-7xl gap-12 px-4 py-16 sm:px-8 lg:grid-cols-4 lg:py-20">
        <div>
          <Link to="/" onClick={nav("")} data-testid="footer-logo" aria-label="Baytaş Tarım ana sayfa">
            <Logo light />
          </Link>
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-paper/60">
            Baytaş Tarım, kaliteli ve güçlü tarım makineleriyle üretiminize değer katar.
            Kültüvatör, çizel, goble, kaldıraç ve diskaro çözümleriniz için yanınızdayız.
          </p>
          <p className="mt-5 inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.18em] text-paper/50">
            <Clock size={14} className="text-amber" />
            {SITE.hours}
          </p>
        </div>

        <div>
          <h3 className="font-mono text-[11px] font-bold uppercase tracking-[0.3em] text-amber">Site</h3>
          <ul className="mt-5 space-y-3 text-sm">
            {NAV.map((item) => (
              <li key={item.hash}>
                <a
                  href={item.hash ? `/#${item.hash}` : "/"}
                  onClick={nav(item.hash)}
                  data-testid={`footer-nav-${item.hash || "anasayfa"}`}
                  className="transition-colors duration-200 hover:text-paper"
                >
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="font-mono text-[11px] font-bold uppercase tracking-[0.3em] text-amber">
            Makinelerimiz
          </h3>
          <ul className="mt-5 space-y-3 text-sm">
            {MACHINES.map((machine) => (
              <li key={machine.slug}>
                <Link
                  to={`/makine/${machine.slug}`}
                  data-testid={`footer-machine-${machine.slug}`}
                  className="transition-colors duration-200 hover:text-paper"
                >
                  {machine.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="font-mono text-[11px] font-bold uppercase tracking-[0.3em] text-amber">İletişim</h3>
          <ul className="mt-5 space-y-4 text-sm">
            {SITE.phones.map((p) => (
              <li key={p.href}>
                <a
                  href={p.href}
                  data-testid={`footer-phone-${p.display.replace(/\s/g, "")}`}
                  className="inline-flex items-start gap-3 transition-colors duration-200 hover:text-paper"
                >
                  <Phone size={16} className="mt-0.5 shrink-0 text-amber" />
                  {p.display}
                </a>
              </li>
            ))}
            <li>
              <a
                href={`mailto:${SITE.email}`}
                data-testid="footer-email"
                className="inline-flex items-start gap-3 transition-colors duration-200 hover:text-paper"
              >
                <Mail size={16} className="mt-0.5 shrink-0 text-amber" />
                {SITE.email}
              </a>
            </li>
            <li>
              <a
                href={SITE.mapsUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-address"
                className="inline-flex items-start gap-3 transition-colors duration-200 hover:text-paper"
              >
                <MapPin size={16} className="mt-0.5 shrink-0 text-amber" />
                {SITE.address}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-2 px-4 py-6 text-xs text-paper/50 sm:flex-row sm:px-8">
          <p data-testid="footer-copyright">© 2026 Baytaş Tarım. Tüm hakları saklıdır.</p>
          <p className="font-mono uppercase tracking-[0.18em]">Tarımın Gücüne Güç Katıyoruz</p>
        </div>
      </div>
    </footer>
  );
}